__turbopack_context__.v({
  "description": "basket-remove-modal-module-scss-module__Jd3T4q__description",
  "modal": "basket-remove-modal-module-scss-module__Jd3T4q__modal",
  "title": "basket-remove-modal-module-scss-module__Jd3T4q__title",
});
